export const SAFETY_REPORTS_DEMO_ROUTE = '/compliance/safety-reports';
export const SAFETY_REPORTS_DEMO_MENU_ID = '/CaseProcessing/SafetyReports';
